import React, { useEffect, useRef, useState } from "react";
import { logo, title } from "../config/config";
import { Link, useLocation } from "react-router-dom";
import { navItems } from "../config/constants";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { East, GeneratingTokens, HelpOutline, HomeOutlined, KeyboardArrowDown, LogoutOutlined, PaymentsOutlined, SettingsOutlined, Widgets } from "@mui/icons-material";
import { useUser } from "../context/UserContext";
import { handleLogout } from "../utils/handleLogout";
import MobileMenuOffcanvas from "./MobileMenuOffcanvas";
import { formatFollowers, totalPrompts } from "../utils/Universalfunctions";
import NewLoginCreditsModal from "../componets/NewLoginCreditsModal";
import { checkAndExpirePlan } from "../utils/DynamicUniversalFunctions";

const Header = () => {
     const auth = localStorage.getItem("auth");
     const { isPremium, userData } = useUser();

     const [show, setShow] = useState(false);
     const handleClose = () => setShow(false);
     const handleShow = () => setShow(true);

     const [isScrolled, setIsScrolled] = useState(false);
     const [openDropdown, setOpenDropdown] = useState(null);
     const [searchTerm, setSearchTerm] = useState("");
     const dropdownRef = useRef(null);
     const location = useLocation();

     useEffect(() => {
          const handleScroll = () => {
               setIsScrolled(window.scrollY > 50);
          };
          window.addEventListener("scroll", handleScroll);
          return () => window.removeEventListener("scroll", handleScroll);
     }, []);

     useEffect(() => {
          const onClickOutside = (e) => {
               if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
                    setOpenDropdown(null);
               }
          };
          document.addEventListener("mousedown", onClickOutside);
          return () => document.removeEventListener("mousedown", onClickOutside);
     }, []);

     const visibleNavItems = navItems.filter((item) => (item.auth ? auth : true));

     const toggleDropdown = (name) => {
          setOpenDropdown((prev) => (prev === name ? null : name));
     };

     useEffect(() => {
          setOpenDropdown(null);
          setSearchTerm("");
     }, [location.pathname]);

     const closeAllMenus = () => {
          setOpenDropdown(null);
          setShow(false);
          setSearchTerm("");
     };

     const getFilteredChildren = (children = []) => {
          const query = searchTerm.trim().toLowerCase();

          if (!query) return children;

          return children
               .map((child) => {
                    const filteredItems =
                         child.items?.filter((subItem) => {
                              const childName = child.name?.toLowerCase() || "";
                              const subItemName = subItem.name?.toLowerCase() || "";
                              const subItemUrl = subItem.url?.toLowerCase() || "";

                              return (
                                   childName.includes(query) ||
                                   subItemName.includes(query) ||
                                   subItemUrl.includes(query)
                              );
                         }) || [];

                    if (filteredItems.length === 0) return null;

                    return {
                         ...child,
                         items: filteredItems
                    };
               })
               .filter(Boolean);
     };



     const [openCreditsModal, setOpenCreditsModal] = useState(false);

     useEffect(() => {
          if (!userData?.uid) return;

          const modalKey = `heyprompt_new_login_credits_modal_${userData.uid}`;
          const alreadyShown = localStorage.getItem(modalKey);

          if (!alreadyShown) {
               setOpenCreditsModal(true);
               localStorage.setItem(modalKey, "shown");
          }
     }, [userData?.uid]);



     useEffect(() => {
          if (!userData?.uid) return;

          checkAndExpirePlan(userData);
     }, [userData]);

     return (
          <>
               <header className={`header ${location.pathname === '/ai-image-generator' && 'header--scrolled'} ${isScrolled ? "header--scrolled" : ""}`}>
                    <div className="__header-in">
                         <div className="header-left">
                              <Link to="/" className="logo-wrapper">
                                   <img src={logo} alt={title} />
                                   <span className="brand-name">{title}</span>
                              </Link>

                              {isPremium && (
                                   <OverlayTrigger
                                        placement="bottom"
                                        overlay={
                                             <Tooltip id="premium-tooltip">
                                                  You’re part of my <b>Exclusive Team</b>!
                                             </Tooltip>
                                        }
                                   >
                                        <Link to="/pricing" className="premium-button">
                                             <span className="premium-icon">🜲</span>
                                             <span className="premium-text">Team Member</span>
                                        </Link>
                                   </OverlayTrigger>
                              )}
                         </div>

                         <div className="header-right">
                              <nav className="desktop-nav" onMouseLeave={() => setOpenDropdown(null)}>
                                   <ul className="nav-links" ref={dropdownRef}>
                                        {visibleNavItems.map((item, index) => {
                                             const hasChildren = Array.isArray(item.children) && item.children.length > 0;

                                             if (hasChildren) {
                                                  const isOpen = openDropdown === item.name;

                                                  if (index === 1 || index === 3) {
                                                       const filteredChildren = getFilteredChildren(item.children);

                                                       return (
                                                            <li
                                                                 key={index}
                                                                 className={`nav-dropdown item-${index} ${isOpen ? "is-open" : ""}`}
                                                                 onMouseEnter={() => setOpenDropdown(item.name)}
                                                            >
                                                                 <div
                                                                      className="dropdown-head"
                                                                      onClick={() => toggleDropdown(item.name)}
                                                                      aria-expanded={isOpen}
                                                                 >
                                                                      <Link to={item.path} className="dropdown-link">
                                                                           {item.name}
                                                                      </Link>
                                                                      <span className="dropdown-caret">▾</span>
                                                                 </div>

                                                                 <div className="dropdown-menu mega-menu">
                                                                      <div className="mega-menu-top">
                                                                           <h3 className="mega-title">
                                                                                {title} Top +{totalPrompts} Prompts Categories
                                                                           </h3>

                                                                           {/* <input
                                                                                type="search"
                                                                                className="form-control"
                                                                                placeholder="Search type, prompts, categories..."
                                                                                value={searchTerm}
                                                                                onChange={(e) => setSearchTerm(e.target.value)}
                                                                           /> */}
                                                                      </div>

                                                                      <div className="mega-menu-inner">
                                                                           {filteredChildren.length > 0 ? (
                                                                                filteredChildren.map((child, i) => (
                                                                                     <div
                                                                                          className={`mega-links ${i === 0 ? "mt-2" : "mt-3"}`}
                                                                                          key={i}
                                                                                     >
                                                                                          {child.items?.map((subItem, subIndex) => (
                                                                                               <Link
                                                                                                    key={subIndex}
                                                                                                    to={subItem.url}
                                                                                                    className={`mega-link-item ${location.pathname === subItem.url
                                                                                                         ? "mega-link-item-active"
                                                                                                         : ""
                                                                                                         }`}
                                                                                                    onClick={closeAllMenus}
                                                                                               >
                                                                                                    <span className="mega-link-text">
                                                                                                         <span className="mega-link-icon-left">
                                                                                                              {child.name}
                                                                                                         </span>
                                                                                                         {subItem.name}
                                                                                                    </span>

                                                                                                    <East className="mega-link-icon-right" />
                                                                                               </Link>
                                                                                          ))}
                                                                                     </div>
                                                                                ))
                                                                           ) : (
                                                                                <div className="mega-links mt-3">
                                                                                     <div className="mega-link-item no-results">
                                                                                          No matching prompts or categories found.
                                                                                     </div>
                                                                                </div>
                                                                           )}
                                                                      </div>
                                                                 </div>
                                                            </li>
                                                       );
                                                  }

                                                  return (
                                                       <li
                                                            key={index}
                                                            className={`nav-dropdown item-${index} ${isOpen ? "is-open" : ""} ${item?.show && item?.show}`}
                                                            onMouseEnter={() => setOpenDropdown(item.name)}
                                                            onMouseLeave={() => setOpenDropdown(null)}
                                                       >
                                                            <div
                                                                 className="dropdown-head"
                                                                 onClick={() => toggleDropdown(item.name)}
                                                                 aria-expanded={isOpen}
                                                            >
                                                                 <Link to={item.path} className="dropdown-link">
                                                                      {item.name}
                                                                 </Link>
                                                                 <span className="dropdown-caret">▾</span>
                                                            </div>

                                                            <div className="dropdown-menu">
                                                                 {item.children.map((child, i) => (
                                                                      <Link
                                                                           key={i}
                                                                           className="dropdown-item"
                                                                           to={child.path}
                                                                           onClick={() => setOpenDropdown(null)}
                                                                      >
                                                                           {child.name}
                                                                      </Link>
                                                                 ))}
                                                            </div>
                                                       </li>
                                                  );
                                             }

                                             return (
                                                  <li key={index} className={`item-${index}`}>
                                                       <Link to={item.path}>{item.name}</Link>
                                                  </li>
                                             );
                                        })}
                                   </ul>
                              </nav>

                              <div className="header-actions">
                                   {auth && (
                                        <div className="profile-container" ref={dropdownRef}>
                                             <button
                                                  className={`account-toggle ${openDropdown === "profile" ? "active" : ""}`}
                                                  onClick={() => toggleDropdown("profile")}
                                             >
                                                  <div className="avatar-mini">
                                                       <img src={userData?.photoURL || logo} alt="user" />
                                                  </div>
                                                  <span>Account</span>
                                                  <KeyboardArrowDown className="arrow-icon" />
                                             </button>

                                             {openDropdown === "profile" && (
                                                  <div className="profile-dropdown">
                                                       <div className="user-info-card">
                                                            <div className="avatar-large">
                                                                 <img src={userData?.photoURL} alt="user" />
                                                            </div>
                                                            <div className="user-details">
                                                                 <h4>{userData?.name}</h4>
                                                                 <p>{userData?.email}</p>
                                                            </div>
                                                       </div>

                                                       <div className="dropdown-links-group">
                                                            <Link to="/account" className="p-item">
                                                                 <div className="p-label">
                                                                      <HomeOutlined /> Dashboard
                                                                 </div>
                                                                 <span className="p-shortcut">
                                                                      <GeneratingTokens /> {formatFollowers(userData?.generation_credits)}
                                                                 </span>
                                                            </Link>

                                                            <Link to="/profile" className="p-item">
                                                                 <div className="p-label">
                                                                      <SettingsOutlined /> Profile
                                                                 </div>
                                                            </Link>

                                                            <Link to="/pricing?subscription" className="p-item">
                                                                 <div className="p-label">
                                                                      <PaymentsOutlined /> {isPremium ? "Exclusive Member" : "Pricing"}
                                                                 </div>
                                                                 <span className="p-badge bg-info">
                                                                      {isPremium ? "Paid" : "FREE"}
                                                                 </span>
                                                            </Link>
                                                       </div>

                                                       <hr className="divider" />

                                                       <div className="dropdown-links-group">
                                                            <Link to="/support" className="p-item">
                                                                 <div className="p-label">
                                                                      <HelpOutline /> Support
                                                                 </div>
                                                            </Link>

                                                            <Link to="/contact" className="p-item">
                                                                 <div className="p-label">
                                                                      <HelpOutline /> Contact Us
                                                                 </div>
                                                            </Link>

                                                            <button
                                                                 onClick={() => handleLogout("/login")}
                                                                 className="p-item logout-btn"
                                                            >
                                                                 <div className="p-label">
                                                                      <LogoutOutlined /> Logout
                                                                 </div>
                                                            </button>
                                                       </div>
                                                  </div>
                                             )}
                                        </div>
                                   )}

                                   <Link to={auth ? "/submit" : "/login"} className="btn-modern">
                                        {auth ? "Submit Prompts" : "Login Now"}
                                   </Link>

                                   <button
                                        type="button"
                                        onClick={handleShow}
                                        className="menu-toggle"
                                        aria-label="Open menu"
                                   >
                                        <Widgets />
                                   </button>
                              </div>
                         </div>
                    </div>
               </header>

               <MobileMenuOffcanvas
                    show={show}
                    handleClose={handleClose}
                    setShow={setShow}
                    title={title}
                    auth={auth}
                    navItems={navItems}
               />


               <NewLoginCreditsModal
                    open={openCreditsModal}
                    onClose={() => setOpenCreditsModal(false)}
                    userData={userData}
               />
          </>
     );
};

export default Header;